import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../classes/constants/routeConstants";
import IconsEnum from "../../classes/enums/IconsEnum";
import useTranslation from "../../hooks/i18n/useTranslation";
import { useAuth } from "../../hooks/useAuth";
import { ReactComponent as UserIcon } from "../../icons/User.svg";
import SettingsButton from "../settingsButton/SettingsButton";
import "./UserDropdown.css";

const UserDropdown = ({ isOpen }) => {
  const { t } = useTranslation();
  const { logout, claims } = useAuth();
  const navigate = useNavigate();

  const handleNavigateToSettings = () => {
    navigate(ROUTES.SETTINGS);
  };

  if (!isOpen) return null;

  return (
    <div className={`user-dropdown ${isOpen ? "active" : ""}`}>
      <div className="user-info">
        <div className="user-photo">
          <UserIcon />
        </div>
        <div className="user-details">
          <div className="App-title-widgets">{claims.fullName}</div>
          <div className="App-text-small">
            <span className="role-label">Role:</span>{" "}
            {claims.roles.join(", ") || "N/A"}
          </div>
        </div>
      </div>
      <div className="user-settings">
        <SettingsButton
          label={t("25")}
          icon={IconsEnum.SETTINGS}
          onClick={handleNavigateToSettings}
        />
        <SettingsButton
          label={t("135")}
          icon={IconsEnum.LOGOUT}
          onClick={logout}
        />
      </div>
    </div>
  );
};

export default UserDropdown;
